import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { FaLock, FaCheckCircle, FaExclamationCircle, FaTimes } from 'react-icons/fa';
import './ChangePinModal.css';
import API_BASE_URL from '../../config/api';

const ChangePinModal = ({ isOpen, onClose, userType = 'admin' }) => {
  const [currentPin, setCurrentPin] = useState('');
  const [newPin, setNewPin] = useState('');
  const [confirmNewPin, setConfirmNewPin] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    if (newPin.length !== 4) {
      setError('O novo PIN deve ter exatamente 4 dígitos.');
      return;
    }

    if (newPin !== confirmNewPin) {
      setError('A confirmação do novo PIN não coincide.');
      return;
    }

    setIsLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/auth/change-admin-pin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ currentPin, newPin, confirmNewPin })
      });

      if (response.ok) {
        setMessage('PIN alterado com sucesso.');
        setCurrentPin('');
        setNewPin('');
        setConfirmNewPin('');
        setTimeout(() => {
          onClose();
          setMessage(null);
        }, 2000);
      } else {
        const err = await response.json();
        setError(err.message || 'Erro ao alterar o PIN. Verifique se o PIN atual está correto.');
      }
    } catch (err) {
      console.error('Error changing PIN:', err);
      setError('Erro de ligação ao servidor.');
    } finally {
      setIsLoading(false);
    }
  };

  const handlePinChange = (setter) => (e) => {
    const val = e.target.value.replace(/\D/g, '');
    if (val.length <= 4) setter(val);
  };

  return ReactDOM.createPortal(
    <div className="pin-modal-overlay" onClick={onClose}>
      <div className="pin-modal-container" onClick={e => e.stopPropagation()}>
        <div className="pin-modal-header">
          <div className="pin-header-main">
            <div className="pin-icon-circle">
              <FaLock />
            </div>
            <h3>Segurança e Acesso</h3>
          </div>
          <button className="pin-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="pin-modal-body">
            Altere o seu PIN de 4 dígitos para acesso à sua dashboard de {userType === 'admin' ? 'administração' : (userType === 'coordenador' ? 'coordenador' : 'treinador')}.

          <div className="pin-info-box">
            <FaExclamationCircle />
            <p>Se ainda usa o PIN universal (1234), recomendamos que o altere agora.</p>
          </div>

          {message && (
            <div className="pin-alert pin-alert-success">
              <FaCheckCircle /> {message}
            </div>
          )}

          {error && (
            <div className="pin-alert pin-alert-error">
              <FaExclamationCircle /> {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="pin-modal-form">
            <div className="pin-form-group">
              <label>PIN Atual</label>
              <input
                type="password"
                value={currentPin}
                onChange={handlePinChange(setCurrentPin)}
                placeholder="••••"
                maxLength={4}
                inputMode="numeric"
                required
                disabled={isLoading}
                autoComplete="off"
              />
            </div>

            <div className="pin-form-group">
              <label>Novo PIN (4 dígitos)</label>
              <input
                type="password"
                value={newPin}
                onChange={handlePinChange(setNewPin)}
                placeholder="••••"
                maxLength={4}
                inputMode="numeric"
                required
                disabled={isLoading}
                autoComplete="off"
              />
            </div>

            <div className="pin-form-group">
              <label>Confirmar Novo PIN</label>
              <input
                type="password"
                value={confirmNewPin}
                onChange={handlePinChange(setConfirmNewPin)}
                placeholder="••••"
                maxLength={4}
                inputMode="numeric"
                required
                disabled={isLoading}
                autoComplete="off"
              />
            </div>

            <button
              type="submit"
              className="pin-submit-btn"
              disabled={isLoading || !currentPin || newPin.length !== 4 || confirmNewPin.length !== 4}
            >
              {isLoading ? 'A alterar...' : 'Alterar PIN'}
            </button>
          </form>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ChangePinModal;
